export const getSafeAuthRedirectPath = (redirect = '') => {
  const value = String(redirect || '').trim();

  if (!value) return '';
  if (!value.startsWith('/')) return '';
  if (value.startsWith('//')) return '';

  return value;
};

export default getSafeAuthRedirectPath;
